import { formatGeoJSON } from 'screens/Property/helpers/formatGeoJson';

/**
 * Creates a field feature with standardized properties
 * @param {Object} field - The field object containing geometry and properties
 * @param {string} farmId - The ID of the parent farm
 * @returns {Object} GeoJSON feature object
 */
export const createFieldFeature = (field, farmId) => ({
  type: 'Feature',
  geometry: field.geometry,
  properties: {
    ...field,
    id: field.id,
    name: field.name,
    $landType: 'field',
    $layer: 'default',
    propertyId: farmId,
    cropzones: field.cropzones || []
  }
});

/**
 * Processes farm fields and creates a formatted GeoJSON FeatureCollection
 * @param {Object} farm - Farm object containing fields array
 * @returns {Object|null} Formatted GeoJSON FeatureCollection or null if no valid fields
 */
export const processFarmFields = farm => {
  if (!farm?.fields?.length) return null;

  const features = farm.fields
    .filter(field => field?.geometry)
    .map(field => createFieldFeature(field, farm.id));

  const farmFieldsGeoJSON = {
    type: 'FeatureCollection',
    features
  };

  return formatGeoJSON(farmFieldsGeoJSON);
};

/**
 * Processes all fields from multiple farms and creates a formatted GeoJSON FeatureCollection
 * @param {Array} properties - Array of farm/property objects
 * @returns {Object|null} Formatted GeoJSON FeatureCollection or null if no valid fields
 */
export const processAllFarmFields = properties => {
  const allFields = properties.flatMap(
    farm => farm.fields?.map(field => createFieldFeature(field, farm.id)) || []
  );

  if (!allFields.length) return null;

  const allFieldsGeoJSON = {
    type: 'FeatureCollection',
    features: allFields.filter(f => f.geometry)
  };

  return formatGeoJSON(allFieldsGeoJSON);
};
